import UpdatePassword from "./updatePassword";
export default UpdatePassword